import { AlertType } from '@aloft/toolkit-shared';

import toast from 'react-hot-toast';

import { syncAlertHoverPreview } from '../../modules/alerts/syncAlertHoverPreview.ts';
import { clearAlertsPanelAutoOpenedForNavBlock } from '../../redux/features/referenceBarUISlice.ts';
import { suppressAlertToasts } from '../../redux/features/uiSlice.ts';
import { store } from '../../redux/store.ts';
import { AlertKey, getAlertToastId } from './constants.ts';

const registeredAlertToastKeys = new Set<AlertKey>();

const getAlertTypeFromToastKey = (alertKey: AlertKey): AlertType =>
  alertKey.split('#')[0] as AlertType;

export const registerAlertToast = (alertKey: AlertKey) => {
  registeredAlertToastKeys.add(alertKey);
};

export const isAlertToastRegistered = (alertKey: AlertKey) =>
  registeredAlertToastKeys.has(alertKey);

export const unregisterAlertToast = (alertKey: AlertKey) => {
  if (!registeredAlertToastKeys.delete(alertKey)) return;
  toast.remove(getAlertToastId(alertKey));
};

export const dismissAlertToastUI = () => {
  registeredAlertToastKeys.forEach((alertKey) => {
    toast.remove(getAlertToastId(alertKey));
  });
  registeredAlertToastKeys.clear();
};

export const dismissInactiveAlertToasts = (activeAlertKeys: ReadonlySet<AlertKey>) => {
  [...registeredAlertToastKeys].forEach((alertKey) => {
    if (!activeAlertKeys.has(alertKey)) {
      unregisterAlertToast(alertKey);
    }
  });
};

export const dismissAllToasts = () => {
  toast.dismiss();
};

export const suppressAlertToast = (alertKey: AlertKey) => {
  store.dispatch(suppressAlertToasts([getAlertTypeFromToastKey(alertKey)]));
  unregisterAlertToast(alertKey);
};

export const dismissAlertToasts = () => {
  const alertTypes = [...registeredAlertToastKeys].map(getAlertTypeFromToastKey);
  if (alertTypes.length > 0) {
    store.dispatch(suppressAlertToasts(alertTypes));
  }
  store.dispatch(clearAlertsPanelAutoOpenedForNavBlock());
  syncAlertHoverPreview(store.dispatch, null);
  dismissAlertToastUI();
  toast.dismiss();
};
